import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "mapContainer",
  class: "w-full h-[calc(100%-3rem)] relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorOverlay = _resolveComponent("ErrorOverlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ErrorOverlay, {
      show: _ctx.showErrorOverlay,
      icon: "error_outline",
      message: _ctx.errorMessage
    }, null, 8, ["show", "message"])
  ], 512))
}